export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15093.e1464d4f.jpg";